import { Status, UserModel } from "./user.model";

export class PatientPhysician {
  DoctorName: string;
}
export class Patient {
  UserId?: number;
  Id?: number;
  Suffix?: string;
  FirstName: string;
  LastName: string;
  MiddleName: string;
  Dob: string;
  BirthDay: number;
  BirthMonth: string;
  BirthYear: string;
  Gender: string;
  LocationId?: number;
  LocationName?: string;
  PhlebotomistId?: number;
  PhlebotomistName?: string;
  DoctorId?: number;
  Physician: PatientPhysician;
  DoctorName?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  Zip?: string;
  BillTo?: string;
  BillToText?: string;
  Provider?: string;
  PolicyId?: string;
  GroupNumber?: string;
  Incomplete?: boolean;
  Email?: string;
  Status: Status;
  Phone?: string;

  constructor(params: any = {}) {
    this.Email = params.Email || null;
    this.Status = params.Status || null;
    this.UserId = params.UserId || null;

    this.Id = params.Id || "";
    this.FirstName = params.FirstName || "";
    this.LastName = params.LastName || "";
    this.MiddleName = params.MiddleName || "";
    this.Phone = params.Phone || "";

    this.Suffix = params.Suffix || null;
    this.Gender = params.Gender || null;
    this.State = params.State || null;

    this.BirthDay = params.BirthDay || null;
    this.BirthMonth = params.BirthMonth || null;
    this.BirthYear = params.BirthYear || null;
    this.Dob = params.Dob || null;

    this.LocationId = params.LocationId || null;
    this.LocationName = params.LocationName || null;

    this.DoctorId = params.DoctorId || null;
    this.DoctorName = params.DoctorName || null;

    this.PhlebotomistId = params.PhlebotomistId || null;
    this.PhlebotomistName = params.PhlebotomistName || null;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/patient.model.ts